var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagGuatemala(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C24.8366 32.0107 32 24.8473 32 16.0107C32 7.17419 24.8366 0.0107422 16 0.0107422C7.16344 0.0107422 0 7.17419 0 16.0107C0 24.8473 7.16344 32.0107 16 32.0107Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9996 16.0105C31.9996 9.66714 28.308 4.18614 22.9561 1.59814V30.4228C28.308 27.8349 31.9996 22.3538 31.9996 16.0105Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0105C0 22.3538 3.69156 27.8349 9.0435 30.4229V1.59814C3.69156 4.18614 0 9.66714 0 16.0105Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1807 18.7161L17.4753 16.0107L20.0505 13.4354L19.9338 12.0753L19.1965 11.3379L15.9995 14.5349L12.8025 11.3379L12.0653 12.0753L11.9486 13.4354L14.5238 16.0107L11.8184 18.7161L13.2941 20.1917L15.9995 17.4864L18.705 20.1917L20.1807 18.7161Z",
    fill: "#ACABB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9352 12.0757L18.4595 13.5514C19.0889 14.1808 19.4783 15.0504 19.4783 16.0109C19.4783 17.9319 17.921 19.4891 16.0001 19.4891C14.0791 19.4891 12.5218 17.9319 12.5218 16.0109C12.5218 15.0504 12.9111 14.1808 13.5406 13.5514L12.0649 12.0757C11.0577 13.0827 10.4348 14.474 10.4348 16.0109C10.4348 19.0845 12.9264 21.5761 16 21.5761C19.0736 21.5761 21.5652 19.0844 21.5652 16.0109C21.5652 14.4741 20.9423 13.0827 19.9352 12.0757Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15656"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagGuatemala);
export default __webpack_public_path__ + "static/media/flag_guatemala.0d5ce4fe8b637a8f9a9bda47f8a78a3c.svg";
export { ForwardRef as ReactComponent };